if (!customElements.get('media-gallery')) {
    customElements.define('media-gallery', class extends HTMLElement {
        initialize() {
            this.elements = {
                liveRegion: this.querySelector('[id^="GalleryStatus"]'),
                viewer: this.querySelector('[id^="GalleryViewer"]'),
                thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
            };

            this.autoplayVideosInViewport();

            if (!this.elements.thumbnails) {
                return;
            }

            this.elements.viewer.addEventListener(
                'slideChanged',
                BryanAnthonys.debounce(this.onSlideChanged.bind(this), 500)
            );

            this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
                mediaToSwitch.querySelector('button').addEventListener(
                    'click',
                    this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false)
                );
            });

            if (this.dataset.desktopLayout.includes('thumbnail') && !BryanAnthonys.device.isMobile()) {
                this.removeListSemantic();
            }
        }

        onSlideChanged(event) {
            const thumbnail = this.elements.thumbnails.querySelector(
                `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
            );

            this.setActiveThumbnail(thumbnail);
        }

        setActiveMedia(mediaId, prepend) {
            const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`);

            this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
                element.classList.remove('is-active');
            });

            activeMedia.classList.add('is-active');

            if (prepend) {
                activeMedia.parentElement.prepend(activeMedia);
                if (this.elements.thumbnails) {
                    const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
                    activeThumbnail.parentElement.prepend(activeThumbnail);
                }

                if (this.elements.viewer.slider) {
                    this.elements.viewer.resetPages();
                }
            }

            window.setTimeout(() => {
                if (this.elements.thumbnails) {
                    activeMedia.parentElement.scrollTo({left: activeMedia.offsetLeft});
                }

                if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
                    this.scrollToActiveMedia(activeMedia);
                }
            });

            this.playActiveMedia(activeMedia);

            if (!this.elements.thumbnails) {
                return;
            }
            const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
            this.setActiveThumbnail(activeThumbnail);
            this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
        }

        scrollToActiveMedia(media) {
            if (BryanAnthonys.device.isMobile()) {
                media.closest('slider-component').scrollToFirstSlide();
            } else if (!BryanAnthonys.isElementInViewport(media, 0.5)) {
                window.scrollTo({
                    top: 0,
                    left: 0,
                    behavior: 'smooth'
                });
            }
        }

        setActiveThumbnail(thumbnail) {
            if (!this.elements.thumbnails || !thumbnail) {
                return;
            }

            this.elements.thumbnails.querySelectorAll('button').forEach(
                element => element.removeAttribute('aria-current')
            );

            thumbnail.querySelector('button').setAttribute('aria-current', 'true');

            if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) {
                return;
            }

            this.elements.thumbnails.slider.scrollTo({left: thumbnail.offsetLeft});
        }

        announceLiveRegion(activeItem, position) {
            const image = activeItem.querySelector('.product__modal-opener--image img');
            if (!image) {
                return;
            }

            const announceChange = () => {
                this.elements.liveRegion.setAttribute('aria-hidden', false);
                this.elements.liveRegion.innerHTML = BryanAnthonys.htmlReviewedForSafety(
                    BryanAnthonys.strings.accessibility.imageAvailable.replace('[index]', parseInt(position))
                );
                setTimeout(() => {
                    this.elements.liveRegion.setAttribute('aria-hidden', true);
                }, 2000);
            };

            if (image.complete && image.nat) {
                announceChange();
            } else {
                image.onload = announceChange;
            }
        }

        playActiveMedia(activeItem) {
            window.pauseAllMedia();
            const deferredMedia = activeItem.querySelector('.deferred-media');
            if (deferredMedia) {
                deferredMedia.loadContent(false);
            }
        }

        removeListSemantic() {
            if (!this.elements.viewer.slider) {
                return;
            }
            this.elements.viewer.slider.setAttribute('role', 'presentation');
            this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
        }

        autoplayVideosInViewport() {
            this.videoObserver = null;

            if (!this.getVideos().length) {
                return;
            }

            if (!BryanAnthonys.device.isMobile() && ['columns', 'stacked'].includes(this.dataset.desktopLayout)) {
                this.videoObserver = new IntersectionObserver((entries) => {
                    entries.forEach((entry) => {
                        if (entry.isIntersecting) {
                            this.playVideo(entry.target);
                        } else {
                            this.pauseVideo(entry.target);
                        }
                    });
                });

                this.getVideos().forEach(video => this.videoObserver.observe(video));
            } else if (BryanAnthonys.device.isMobile()) {
                const videos = this.getVideos();
                this.elements.viewer.addEventListener(
                    'slideChanged',
                    BryanAnthonys.debounce(event => {
                        const activeSlideVideo = event.detail.currentElement
                            .querySelector('deferred-media[data-media-type="video"]');
                        videos.forEach(video => {
                            if (activeSlideVideo === video) {
                                this.playVideo(video);
                            } else {
                                this.pauseVideo(video);
                            }
                        });
                    }, 100)
                );
            }
        }

        playVideo(deferredMedia) {
            if (!deferredMedia.getAttribute('loaded')) {
                deferredMedia.loadContent();
            }

            const video = deferredMedia.querySelector('video');

            video.loop = true;
            video.controls = false;

            setTimeout(() => video.play(), 50);
        }

        pauseVideo(deferredMedia) {
            const video = deferredMedia.querySelector('video');

            if (video) {
                video.pause();
            }
        }

        getVideos() {
            return this.querySelectorAll('deferred-media[data-media-type="video"]');
        }

        disconnectedCallback() {
            if (this.videoObserver) {
                this.getVideos().forEach(video => this.videoObserver.unobserve(video));
            }
        }
    });

    customElements.define('media-gallery-initializer', class extends HTMLElement {
        connectedCallback() {
            if (typeof this.parentElement.initialize === 'function') {
                this.parentElement.initialize();
            }
        }
    });
}
